import React, { lazy, Suspense } from 'react';
import {
    createBrowserRouter,
    RouterProvider,
    Navigate,
    redirect
} from 'react-router-dom';
import PageLoader from '../component/loader/PageLoader';
import ErrorBoundary from './ErrorBoundary';
import HomeLayout from './HomeLayout';
import Signin from '../component/Signin';

// Lazy-loaded components
const Home = lazy(() => import('../component/Home'));
const Dashboard = lazy(() => import('../component/Dashboard'));
const About = lazy(() => import('../component/About'));
const Cart = lazy(() => import('../component/Cart'));

const checkAuth = async () => {
    const token = localStorage.getItem('myToken');
    if (!token) {
        return false;
    }

    try {
        const response = await fetch('/auth/verifyToken', {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.ok;
    } catch {
        return false;
    }
};

const protectedLoader = async () => {
    const isAuthenticated = await checkAuth();
    if (!isAuthenticated) {
        return redirect('/home');
    }
    return null;
};

const router = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="/home" replace />
    },

    {
        path: '/home',
        element: <HomeLayout />,
        errorElement: <ErrorBoundary />,
        children: [
            {
                index: true,
                element: <Home />
            },
            {
                path: 'about',
                element: <About />
            },
            {
                path: 'cart',
                element: <Cart />
            },
            {
                path: '*',
                element: <Navigate to='/home' replace />
            }
        ]
    },

    {
        path: '/signin',
        element: <Signin />,
        errorElement: <ErrorBoundary />
    },

    {
        path: 'dashboard',
        element: <Dashboard />,
        loader: protectedLoader
    },
    {
        path: '*',
        element: <Navigate to='/home' replace />
    }
]);

const AppRouters = () => {
    return (
        <Suspense fallback={<PageLoader />}>
            <RouterProvider router={router} />
        </Suspense>
    );
};

export default AppRouters;